var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.847H20.7864V20.5339L17.733 23.5945C17.4554 23.8721 17.007 23.8721 16.7223 23.5945L9.20615 16.0641C8.91434 15.7723 8.93569 15.2954 9.24886 15.0178C11.377 13.1388 14.1671 12 17.2276 12C20.1885 12 22.9003 13.0748 25 14.847ZM22.9217 21.9646C22.5302 21.9646 22.2099 22.2849 22.2099 22.6763C22.2099 23.0678 22.5302 23.3881 22.9217 23.3881C23.3131 23.3881 23.6334 23.0678 23.6334 22.6763C23.6334 22.2849 23.3131 21.9646 22.9217 21.9646ZM22.9217 16.2705C22.5302 16.2705 22.2099 16.5908 22.2099 16.9823V19.8293C22.2099 20.2208 22.5302 20.5411 22.9217 20.5411C23.3131 20.5411 23.6334 20.2208 23.6334 19.8293V16.9823C23.6334 16.5908 23.3131 16.2705 22.9217 16.2705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLoss);
export default __webpack_public_path__ + "static/media/NetworkLoss.0ff7d6c689064d3646e0eb0d355fc7ac.svg";
export { ForwardRef as ReactComponent };